var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmallTent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3527_39939)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3527_39939",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.583984 0.583414H13.4173V13.4167H0.583984V0.583414Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3527_39939)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.833984 4.51237H13.166L12.9154 6.51758H1.08464L0.833984 4.51237Z",
    stroke: "#202842",
    strokeWidth: 0.8,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.84375 4.50903C3.10009 3.93447 5.90114 1.92224 7.00009 0.833937C8.09912 1.92229 10.9003 3.93462 12.1566 4.50903",
    stroke: "#202842",
    strokeWidth: 0.8,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.83594 6.55077C1.83594 8.25742 1.53516 11.2345 1.08398 13.1328",
    stroke: "#202842",
    strokeWidth: 0.8,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1641 6.55077C12.1641 8.25742 12.4648 11.2345 12.916 13.1328",
    stroke: "#202842",
    strokeWidth: 0.8,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.833984 13.166H13.166",
    stroke: "#202842",
    strokeWidth: 0.8,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.70898 4.4939C5.26488 3.92938 6.51144 1.93182 6.99994 0.852388C7.48848 1.93182 8.73504 3.92938 9.29091 4.4939",
    stroke: "#202842",
    strokeWidth: 0.8,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.70837 6.55077C4.70837 8.25742 4.44236 11.2345 4.24219 13.1328",
    stroke: "#202842",
    strokeWidth: 0.8,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.29102 6.55077C9.29102 8.25742 9.55701 11.2345 9.7572 13.1328",
    stroke: "#202842",
    strokeWidth: 0.8,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.74609 13.0408V10.4089C5.74609 9.71964 6.31006 9.15568 6.99935 9.15568C7.68864 9.15568 8.2526 9.71964 8.2526 10.4089V13.0408",
    stroke: "#202842",
    strokeWidth: 0.8,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3527_39939"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallTent);
export default __webpack_public_path__ + "static/media/smallTent.d401795d0b0fb7f5b5264334fe7ee09a.svg";
export { ForwardRef as ReactComponent };